import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0Zm-.643 3a.643.643 0 1 1 1.286 0v2.571a.643.643 0 0 1-1.286 0V3ZM6 9.429a.857.857 0 1 1 0-1.715.857.857 0 0 1 0 1.715Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }